/*!

=========================================================
* Paper Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React from "react";
import { withScriptjs, withGoogleMap, GoogleMap, KmlLayer, Marker } from "react-google-maps";	// react plugin used to create google maps
import { Button, Card, CardHeader, CardBody, Input, InputGroup, InputGroupText, Row, Col } from "reactstrap";	// reactstrap components
import * as utility from 'components/Utils';


class Map extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isAuthorized: localStorage.getItem('isAuthorized'),
			password: '',
			posDab: { lat: 32.992049699999995, lng: -117.09116449999998 },
			posKwb: { lat: 32.991049699999995, lng: -117.09216449999998 }
		}

		this.fetchTheData = this.fetchTheData.bind(this);
		this.handleAuthorizationPassword = this.handleAuthorizationPassword.bind(this);
	}


	componentDidMount() {
		this.fetchTheData();
		this.interval = setInterval(() => this.fetchTheData(), 60*1000);	// periodically refresh the position
	}


	fetchTheData() {
		// console.log("Fetching data from " + this.state.urlData );
		fetch(utility.getRootUrl()+"/getGpsPositions.php")
			.then(response => response.json())
			.then(d => {
					this.setState({ posDab: d.posDab, posKwb: d.posKwb })
			}
		);
	}


	handleAuthorizationPassword( event ) {
		event.preventDefault();

		if ( this.state.password === '00' ) {
			this.setState( { isAuthorized: true } );
			localStorage.setItem('isAuthorized', true );
		}
	}

	setPassword(val) {
		this.setState( { password: val } );
	}


	loginFirst() {
		return (
			<div className="Login">
			  <form onSubmit={this.handleAuthorizationPassword}>
				<InputGroup name="password">
				  <InputGroupText> Unlock Code </InputGroupText>
				  <Input
					value={this.state.password}
					onChange={e => this.setPassword(e.target.value)}
				  />
				</InputGroup>
				<Button block type="submit">
				  Login
				</Button>
			  </form>
			</div>
		);

	}



	render() {

		if ( ! this.state.isAuthorized ) {
			return (
			<div className="content"
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				{this.loginFirst()}
			</div>
			);
		}

/*
		var mapStyling = [
			{
			  featureType: "water",
			  stylers: [
				{
				  saturation: 43
				},
				{
				  lightness: -11
				},
				{
				  hue: "#0088ff"
				}
			  ]
			},
			{
			  featureType: "road",
			  elementType: "geometry.fill",
			  stylers: [
				{
				  hue: "#ff0000"
				},
				{
				  saturation: -100
				},
				{
				  lightness: 99
				}
			  ]
			},
			{
			  featureType: "road",
			  elementType: "geometry.stroke",
			  stylers: [
				{
				  color: "#808080"
				},
				{
				  lightness: 54
				}
			  ]
			},
			{
			  featureType: "landscape.man_made",
			  elementType: "geometry.fill",
			  stylers: [
				{
				  color: "#ece2d9"
				}
			  ]
			},
			{
			  featureType: "poi.park",
			  elementType: "geometry.fill",
			  stylers: [
				{
				  color: "#ccdca1"
				}
			  ]
			},
			{
			  featureType: "road",
			  elementType: "labels.text.fill",
			  stylers: [
				{
				  color: "#767676"
				}
			  ]
			},
			{
			  featureType: "road",
			  elementType: "labels.text.stroke",
			  stylers: [
				{
				  color: "#ffffff"
				}
			  ]
			},
			{
			  featureType: "poi",
			  stylers: [
				{
				  visibility: "off"
				}
			  ]
			},
			{
			  featureType: "landscape.natural",
			  elementType: "geometry.fill",
			  stylers: [
				{
				  visibility: "on"
				},
				{
				  color: "#b8cb93"
				}
			  ]
			},
			{
			  featureType: "poi.park",
			  stylers: [
				{
				  visibility: "on"
				}
			  ]
			},
			{
			  featureType: "poi.sports_complex",
			  stylers: [
				{
				  visibility: "on"
				}
			  ]
			},
			{
			  featureType: "poi.medical",
			  stylers: [
				{
				  visibility: "on"
				}
			  ]
			},
			{
			  featureType: "poi.business",
			  stylers: [
				{
				  visibility: "simplified"
				}
			  ]
			}
		  ]
		;
*/

	  const MapWrapper = withScriptjs(
		withGoogleMap(props => (
		  <GoogleMap
			defaultZoom={12}
			layerTypes={['TrafficLayer', 'TransitLayer']}
			defaultCenter={ { lat: (this.state.posDab.lat + this.state.posKwb.lat) / 2, lng: (this.state.posDab.lng + this.state.posKwb.lng) / 2 } }
			defaultOptions={{
			  scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
			  // styles: mapStyling,

			  mapTypeId: 'satellite',
			  streetViewControl: false,
			  scaleControl: true,
			  fullscreenControl: false,
			  gestureHandling: "greedy",
			  disableDoubleClickZoom: false,
			  minZoom: 3,
			  maxZoom: 18,
			  mapTypeControl: true,
			}}
		  >

			<Marker name="David's Position" title="David" position={this.state.posDab} />
			<Marker name="Kathleen's Position" title="Kathleen" position={this.state.posKwb} />

			<KmlLayer 
			  url='https://beccue.com/sample.kml'
			  options={{ preserveViewport : true}}
			/>
		  </GoogleMap>
		))
	  );

	  return (
		<>
		  <div className="content">
			<Row>
			  <Col md="12">
				<Card>
				  <CardHeader>Google Maps</CardHeader>
				  <CardBody>
					<div
					  id="map"
					  className="map"
					  style={{ position: "relative", overflow: "hidden" }}
					>
					  <MapWrapper
						googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDrpmVZ5RXkUHADtXSuXxHnIVjvULeMd8I"
						loadingElement={<div style={{ height: `100%` }} />}
						containerElement={<div style={{ height: `100%` }} />}
						mapElement={<div style={{ height: `100%` }} />}
						posDab={this.state.posDab}
					  />
					</div>
				  </CardBody>
				</Card>
			  </Col>
			</Row>
		  </div>
		</>
	  );
	}
}

export default Map;
